<template>
  <div id="organisation-billing">
    <div id="hidden"></div>
    <div class="content-wrapper">
      <div class="content animated fadeIn">
        <div class="card">
          <div class="card-header">
            <div class="card-title-container" v-if="activeSubscription != null">
              <h5 class="card-title">{{ $t("organisation.billing.title") }}</h5>
              <span v-if="plansInfo && plansInfo.find(x => x.id == activeSubscription.planId)">
                {{ $t("organisation.billing.currentPlan1") }}
                <b>{{ plansInfo.find(x => x.id == activeSubscription.planId).title }}</b>
                {{ $t("organisation.billing.currentPlan2") }}
              </span>
            </div>
            <div class="header-elements" style="display:flex;gap:10px; align-items:center;margin-left:auto;">
              <el-button size="small" round type="primary" @click="redeemCodeModal = !redeemCodeModal">{{ $t("redeemModal.title") }}</el-button>
              <el-button-group >
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :loading="loading == 'refreshPlans'" icon="fas fa-redo-alt" size="mini" @click="refreshPlans" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.details')" placement="top">
                  <el-button :icon="showPlans ? 'fas fa-angle-up' : 'fas fa-angle-down'" size="mini" v-if="activeSubscription != null" @click="showPlans = !showPlans" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="card-body" v-if="showPlans">
            <div class="free-plan-card" v-if="activeSubscription != null">
              <div class="plan-header">
                <h3 v-if="plansInfo.find(x => x.id == activeSubscription.planId) != null && !activeSubscription.lifetime">{{ plansInfo.find(x => x.id == activeSubscription.planId).title }} {{ $t("organisation.billing.plan") }}</h3>
                <el-badge value="Lifetime" v-if="plansInfo.find(x => x.id == activeSubscription.planId) != null && activeSubscription.lifetime" class="item" type="primary">
                  <h3>{{ plansInfo.find(x => x.id == activeSubscription.planId).title }} {{ $t("organisation.billing.plan") }}</h3>
                </el-badge>
                <span v-if="plansInfo.filter(x => x.isFree == true).id == activeSubscription.planId">{{ $t("organisation.billing.freePlanStart") }}</span>
                <span v-else>{{ $t("organisation.billing.planMsg") }}</span>

                <!-- <span
                  >{{ $t('organisation.billing.toFreeText1') }} <button type="text" @click="buyPlans(item.id)">{{ $t('organisation.billing.toFreeBtn') }}</button
                  >{{ $t('organisation.billing.toFreeText2') }}.</span
                > -->
                <template v-if="!activeSubscription.isFree">
                  <template v-if="activeSubscription.isCancelled == true">
                    <span>
                      {{ $t("organisation.billing.toCancelToCancelText1") }}
                      <el-popconfirm @confirm="cancelCancelSubscription(activeSubscription.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('organisation.billing.cancelCancelSubscriptionTitle')">
                        <button type="text" slot="reference">{{ $t("organisation.billing.toCancelToCancelBtn") }}{{ $t("organisation.billing.toCancelToCancelText2") }}</button>
                      </el-popconfirm>
                    </span>
                  </template>

                  <template v-if="activeSubscription.isCancelled == false">
                    <span>
                      {{ $t("organisation.billing.toCancelText1") }}
                      <el-popconfirm @confirm="cancelSubscription(activeSubscription.id)" style="display:inline-block;" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('organisation.billing.cancelSubscriptionTitle')">
                        <button type="text" slot="reference">{{ $t("organisation.billing.toCancelBtn") }}{{ $t("organisation.billing.toCancelToCancelText2") }}</button>
                      </el-popconfirm>
                    </span>
                  </template>
                </template>
              </div>
              <div class="plan-footer">
                <el-tag effect="dark" v-if="overviewInfo.currentPlan != null && overviewInfo.currentPlan.title.toLowerCase().includes('lifetime') == true">Lifetime</el-tag>
                <el-tag effect="dark" v-else>
                  <span>
                    {{
                      $moment(activeSubscription.startDate)
                        .utc()
                        .format("MMM DD, YYYY")
                    }}
                    <i class="fas fa-long-arrow-alt-right"></i>
                    {{
                      $moment(activeSubscription.endDate)
                        .utc()
                        .format("MMM DD, YYYY")
                    }}
                  </span>
                </el-tag>
              </div>
            </div>
            <div class="free-plan-card mt-2" v-if="activeStorageSubscription != null">
              <div class="plan-header">
                <h3 v-if="additionalPlans.find(x => x.id == activeStorageSubscription.planId) != null">{{ additionalPlans.find(x => x.id == activeStorageSubscription.planId).title }} {{ $t("organisation.billing.plan") }}</h3>

                <span v-if="additionalPlans.filter(x => x.isFree == true).id == activeStorageSubscription.planId">{{ $t("organisation.billing.freePlanStart") }}</span>
                <span v-else>{{ $t("organisation.billing.planMsg") }}</span>

                <!-- <span
                  >{{ $t('organisation.billing.toFreeText1') }} <button type="text" @click="buyPlans(item.id)">{{ $t('organisation.billing.toFreeBtn') }}</button
                  >{{ $t('organisation.billing.toFreeText2') }}.</span
                > -->
                <template v-if="!activeStorageSubscription.isFree">
                  <template v-if="activeStorageSubscription.isCancelled == true">
                    <span>
                      {{ $t("organisation.billing.toCancelToCancelText1") }}
                      <el-popconfirm @confirm="cancelCancelSubscription(activeStorageSubscription.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('organisation.billing.cancelCancelSubscriptionTitle')">
                        <button type="text" slot="reference">{{ $t("organisation.billing.toCancelToCancelBtn") }}{{ $t("organisation.billing.toCancelToCancelText2") }}</button>
                      </el-popconfirm>
                    </span>
                  </template>

                  <template v-if="activeStorageSubscription.isCancelled == false">
                    <span>
                      {{ $t("organisation.billing.toCancelText1") }}
                      <el-popconfirm @confirm="cancelSubscription(activeStorageSubscription.id)" style="display:inline-block;" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('organisation.billing.cancelSubscriptionTitle')">
                        <button type="text" slot="reference">{{ $t("organisation.billing.toCancelBtn") }}{{ $t("organisation.billing.toCancelToCancelText2") }}</button>
                      </el-popconfirm>
                    </span>
                  </template>
                </template>
              </div>
              <div class="plan-footer">
                <el-tag effect="dark">
                  <span>
                    {{ $moment(activeStorageSubscription.startDate).format("MMM DD, YYYY") }}
                    <i class="fas fa-long-arrow-alt-right"></i>
                    {{ $moment(activeStorageSubscription.endDate).format("MMM DD, YYYY") }}
                  </span>
                </el-tag>
              </div>
            </div>
            <div class="free-plan-card mt-2" v-if="activeTeamMemberSubscription != null">
              <div class="plan-header">
                <h3 v-if="additionalPlans.find(x => x.id == activeTeamMemberSubscription.planId) != null">{{ additionalPlans.find(x => x.id == activeTeamMemberSubscription.planId).title }} {{ $t("organisation.billing.plan") }}</h3>

                <span v-if="additionalPlans.filter(x => x.isFree == true).id == activeTeamMemberSubscription.planId">{{ $t("organisation.billing.freePlanStart") }}</span>
                <span v-else>{{ $t("organisation.billing.planMsg") }}</span>

                <!-- <span
                  >{{ $t('organisation.billing.toFreeText1') }} <button type="text" @click="buyPlans(item.id)">{{ $t('organisation.billing.toFreeBtn') }}</button
                  >{{ $t('organisation.billing.toFreeText2') }}.</span
                > -->
                <template v-if="!activeTeamMemberSubscription.isFree">
                  <template v-if="activeTeamMemberSubscription.isCancelled == true">
                    <span>
                      {{ $t("organisation.billing.toCancelToCancelText1") }}
                      <el-popconfirm @confirm="cancelCancelSubscription(activeTeamMemberSubscription.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('organisation.billing.cancelCancelSubscriptionTitle')">
                        <button type="text" slot="reference">{{ $t("organisation.billing.toCancelToCancelBtn") }}{{ $t("organisation.billing.toCancelToCancelText2") }}</button>
                      </el-popconfirm>
                    </span>
                  </template>

                  <template v-if="activeTeamMemberSubscription.isCancelled == false">
                    <span>
                      {{ $t("organisation.billing.toCancelText1") }}
                      <el-popconfirm @confirm="cancelSubscription(activeTeamMemberSubscription.id)" style="display:inline-block;" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('organisation.billing.cancelSubscriptionTitle')">
                        <button type="text" slot="reference">{{ $t("organisation.billing.toCancelBtn") }}{{ $t("organisation.billing.toCancelToCancelText2") }}</button>
                      </el-popconfirm>
                    </span>
                  </template>
                </template>
              </div>
              <div class="plan-footer">
                <el-tag effect="dark">
                  <span>
                    {{ $moment(activeTeamMemberSubscription.startDate).format("MMM DD, YYYY") }}
                    <i class="fas fa-long-arrow-alt-right"></i>
                    {{ $moment(activeTeamMemberSubscription.endDate).format("MMM DD, YYYY") }}
                  </span>
                </el-tag>
              </div>
            </div>

            <div class="enterprise-plan-card" v-if="activeSubscription == null && plansInfo && plansInfo.length > 0">
              <div class="plan-header">
                <h3>Start subscription</h3>
                <span>You don't have any active subscription</span>
                <span>You can start subscription here for $49.99 / monthly</span>
              </div>
              <div class="plan-footer">
                <el-button @click="buyPlans(plansInfo.filter(x => x.isFree == false)[0])" type="primary">Start subscription</el-button>
              </div>
            </div>

            <div class="additional-package-list mt-2">
                  <div class="additional-package-item" v-for="additionalPackage in additionalPlans.filter(x => x.additionalPackageType == parseInt(0))" :key="additionalPackage.id">
                    <div class="additional-package-title">{{ $currency.format(additionalPackage.price, { code: "USD" }) }}</div>
                    <div class="additional-package-desc" v-if="additionalPackage.values[0]">{{ additionalPackage.values[0].description }}</div>
                    <div class="additional-package-price" v-if="additionalPackage.values[0]">{{ additionalPackage.values[0].title }}</div>
                    <div class="additional-package-input"><el-input-number size="mini" :min="1" v-model="additionalPackage.count"></el-input-number></div>
                    <div class="additional-package-buy-button" :key="additionalPackage.count + '-package-count-' + additionalPackage.id">
                      <el-button size="mini" type="primary" @click="buyPackage(additionalPackage)" :disabled="activeSubscription != null && (additionalPackage.count == 0 || activeSubscription.isFree)">{{ $t("organisation.billing.buy") }}</el-button>
                    </div>
                    
                  </div>
                </div>

            
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ $t("organisation.billing.registerCards") }}</h5>
              <span v-if="currentPaymentMethods.length > 0" v-html="$t('organisation.billing.primaryPaymentCard', [currentPaymentMethods.find(x => x.isPrimary == true).bin])"></span>
              <span v-else>{{ $t("organisation.billing.noPrimaryCard") }}</span>
            </div>
            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :loading="loading == 'refreshPaymentMethods'" icon="fas fa-redo-alt" size="mini" @click="refreshPaymentMethods" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.details')" placement="top">
                  <el-button :icon="showCards ? 'fas fa-angle-up' : 'fas fa-angle-down'" size="mini" @click="showCards = !showCards" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="card-body" v-if="showCards">
            <el-row class="mt-2">
              <el-table ref="multipleTable" :data="currentPaymentMethods" style="width: 100%" :stripe="true" :row-class-name="tableRowClassName">
                <el-table-column :label="$t('organisation.billing.cardNo')" width="240">
                  <template slot-scope="scope">
                    <span>{{ scope.row.bin }}**********</span>
                    <el-tag effect="light" type="warning" v-if="scope.row.isPrimary">
                      {{ $t("organisation.billing.primaryCard") }}
                    </el-tag>
                  </template>
                </el-table-column>
                <el-table-column :label="$t('organisation.billing.cardFamily')">
                  <template slot-scope="scope">{{ scope.row.cardAssociation }} {{ scope.row.cardFamily }}</template>
                </el-table-column>

                <el-table-column width="300">
                  <template slot-scope="scope">
                    <div class="errcount" v-if="scope.row.errorCount > 0">
                      <span class="text-danger">{{ scope.row.lastErrorMessage }}</span>
                      <span class="autocheckin-click" @click.stop="resetPaymentMethodErrorCount(scope.row.id)">{{ $t("organisation.billing.buyMsg") }}</span>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('organisation.billing.operation')" width="150">
                  <template slot-scope="scope">
                    <div class="cards-proc">
                      <el-tooltip :content="$t('organisation.billing.makePrimaryCard')" placement="top" class="mr-2">
                        <el-button size="mini" v-if="!scope.row.isPrimary" type="primary" icon="el-icon-bank-card" :loading="setCardLoading == scope.row.id" @click="setPrimaryCard(scope.row.id)" circle></el-button>
                      </el-tooltip>
                      <el-popconfirm @confirm="deletePaymentMethod(scope.row.id)" :confirmButtonText="$t('event.variables.yes')" :cancelButtonText="$t('event.buttons.cancel')" icon="el-icon-info" iconColor="red" :title="$t('event.textbox.toDelete')">
                        <el-button slot="reference" size="mini" type="danger" icon="fas fa-trash" circle></el-button>
                      </el-popconfirm>
                    </div>
                  </template>
                </el-table-column>
              </el-table>
            </el-row>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ $t("organisation.billing.paymentHistory") }}</h5>
              <span v-if="paymentHistory.items.length > 0 && paymentHistory.items.find(x => x.status == 1)">
                {{ $t("organisation.billing.successPaymentText1") }}
                <b>{{ $moment(paymentHistory.items.find(x => x.status == 1).createDate).format("DD MMMM YYYY HH:mm") }}</b>
                {{ $t("organisation.billing.successPaymentText2") }}.
              </span>
              <span v-else>{{ $t("organisation.billing.noSuccessPayment") }}</span>
            </div>
            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :loading="loading == 'refreshPaymentHistory'" icon="fas fa-redo-alt" size="mini" @click="refreshPaymentHistory" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.details')" placement="top">
                  <el-button :icon="showPaymentHistory ? 'fas fa-angle-up' : 'fas fa-angle-down'" size="mini" @click="showPaymentHistory = !showPaymentHistory" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="card-body" v-if="showPaymentHistory">
            <el-row class="mt-2" :key="paymentHistory.items.length + '-payment-history-list-length'">
              <el-table ref="multipleTable" :data="paymentHistory.items" style="width: 100%">
                <el-table-column :label="$t('organisation.billing.paymentHistoryPayment')" width="160" fixed="left">
                  <template slot-scope="scope">
                    <span>#{{ scope.row.paymentId }}</span>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('organisation.billing.paymentHistoryPlan')" min-width="220">
                  <template slot-scope="scope">
                    <div class="subs-plan">
                      <span>{{ scope.row.plan.title }}</span>
                      <span v-if="scope.row.isAdditionalPackage == false">
                        {{ $moment(scope.row.startDate).format("MMM DD, YYYY") }}
                        <i class="fas fa-long-arrow-alt-right"></i>
                        {{ $moment(scope.row.endDate).format("MMM DD, YYYY") }}
                      </span>
                      <span v-else>{{ scope.row.additionalPackageCount }} {{ $t("organisation.billing.piece") }}</span>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('organisation.billing.paymentHistoryAmount')" width="120" stripe>
                  <template slot-scope="scope">
                    <span>{{ $currency.format(scope.row.paidPrice, { code: getEnumsDisplay("Currency", scope.row.currency) }) }}</span>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('organisation.billing.paymentHistorySituation')" width="200">
                  <template slot-scope="scope">
                    <div class="payment-status">
                      <span v-if="scope.row.paidPrice > 0">{{ getEnumsDisplay("SubscriptionPaymentHistoryStatus", scope.row.status) }}</span>
                      <span v-else>
                        {{ $t("organisation.billing.freePayment") }}
                      </span>
                      <span>{{ $moment(scope.row.createDate).format("DD MMMM YYYY HH:mm") }}</span>
                    </div>
                  </template>
                </el-table-column>

                <el-table-column :label="$t('organisation.billing.paymentHistoryInvoice')" width="160">
                  <template slot-scope="scope">
                    <template v-if="scope.row.paidPrice > 0">
                      <span v-if="scope.row.invoiceReady == false">
                        <el-button
                          class="share-button"
                          effect="light"
                          type="warning"
                          size="small"
                          icon="fas fa-clock"
                          @click="
                            {
                            }
                          "
                          disabled
                          round
                        >
                          {{ $t("organisation.billing.preparing") }}
                        </el-button>
                      </span>
                      <span v-else>
                        <el-button class="share-button" effect="light" type="primary" size="small" :loading="loading == scope.row.id + '-history-download'" icon="fas fa-download" @click.stop="openInvoice(scope.row)" round>{{ $t("organisation.billing.download") }}</el-button>
                      </span>
                    </template>
                  </template>
                </el-table-column>
              </el-table>
              <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page.sync="filter.skip" :page-sizes="[20, 30, 40, 50]" :page-size="filter.take" layout="prev, pager, next" :total="paymentHistory.total"></el-pagination>
            </el-row>
          </div>
        </div>
        <div class="card">
          <div class="card-header">
            <div class="card-title-container">
              <h5 class="card-title">{{ $t("organisation.billing.invoiceReceipt") }}</h5>
              <!-- <span v-if="currentOrganization && currentOrganization.invoice" v-html="$t('organisation.billing.invoiceUpdateDate', [$moment(currentOrganization.createDate).format('DD MMMM YYYY HH:mm')])"> </span>
              <span v-else> {{ $t("organisation.billing.noInvoice") }} </span> -->
            </div>
            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button type="success" :loading="loading == 'refreshBilling'" icon="fas fa-redo-alt" size="mini" @click="refreshBilling" round></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.details')" placement="top">
                  <el-button :icon="showInvoice ? 'fas fa-angle-up' : 'fas fa-angle-down'" size="mini" @click="showInvoice = !showInvoice" round></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <div class="card-body" v-if="showInvoice">
            <el-row class="mt-2" :gutter="10" v-if="currentOrganization && currentOrganization.invoice">
              <el-col :span="24" class="mb-2">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("organisation.billing.organizationType") }}</label>
                  </div>
                  <el-select v-model="currentOrganization.invoice.type" v-if="getEnums.find(x => x.title == 'OrganizationInvoiceType').enums">
                    <el-option v-for="(item, index) in getEnums.find(x => x.title == 'OrganizationInvoiceType').enums" :key="'organization-type-' + index" :value="item.key" :label="item.displayName"></el-option>
                  </el-select>
                </div>
              </el-col>
              <el-col :span="24" class="mb-2">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ currentOrganization.invoice.type == 1 ? $t("organisation.billing.companyName") : $t("organisation.billing.nameSurname") }}</label>
                  </div>
                  <el-input v-model="currentOrganization.invoice.titleOrFullName"></el-input>
                  <span class="error">{{ $errorMessage("titleOrFullName", validation) }}</span>
                </div>
              </el-col>
              <el-col :span="12" class="mb-2">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("organisation.billing.taxOffice") }}</label>
                  </div>
                  <el-input v-model="currentOrganization.invoice.taxOffice"></el-input>
                  <span class="error">{{ $errorMessage("taxOffice", validation) }}</span>
                </div>
              </el-col>
              <el-col :span="12" class="mb-2">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ currentOrganization.invoice.type == 2 ? $t("organisation.billing.idNo") : $t("organisation.billing.taxNo") }}</label>
                  </div>
                  <el-input v-model="currentOrganization.invoice.taxNumberOrIdentity"></el-input>
                  <span class="error">{{ $errorMessage("taxNumberOrIdentity", validation) }}</span>
                </div>
              </el-col>
              <el-col :span="8" class="mb-2">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("organisation.billing.country") }}</label>
                  </div>
                  <el-select v-model="currentOrganization.invoice.country" filterable>
                    <el-option v-for="(country, index) in countryList" :key="'country-item-' + index" :label="country.title" :value="country.title"></el-option>
                  </el-select>
                  <span class="error">{{ $errorMessage("country", validation) }}</span>
                </div>
              </el-col>
              <el-col :span="8" class="mb-2">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("organisation.billing.city") }}</label>
                  </div>
                  <el-input v-model="currentOrganization.invoice.city" @clear="currentOrganization.invoice.city = null" clearable></el-input>
                  <span class="error">{{ $errorMessage("city", validation) }}</span>
                </div>
              </el-col>
              <el-col :span="8" class="mb-2">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("organisation.billing.zipCode") }}</label>
                  </div>
                  <el-input v-model="currentOrganization.invoice.zipCode"></el-input>
                  <span class="error">{{ $errorMessage("zipCode", validation) }}</span>
                </div>
              </el-col>
              <el-col :span="24" class="mb-2">
                <div class="registerform-input-container">
                  <div class="custom-label">
                    <label>{{ $t("organisation.billing.address") }}</label>
                  </div>
                  <el-input v-model="currentOrganization.invoice.address" type="textarea" :rows="2"></el-input>
                  <span class="error">{{ $errorMessage("address", validation) }}</span>
                </div>
              </el-col>
            </el-row>
          </div>

          <div class="card-footer end" v-if="showInvoice">
            <el-button type="primary" :loading="loading == 'updateBilling'" @click="updateBilling" round>{{ $t("organisation.billing.save") }}</el-button>
          </div>
        </div>
      </div>
    </div>

    <el-dialog :title="$t('organisation.billing.changePlan')" :visible.sync="buyPlanDialog" class="large" center modal-append-to-body :destroy-on-close="true" @closed="handleClose">
      <div id="changeplan-dialog" class="custom-modal">
        <div class="modal-body" :key="resetPaymentDialog">
          <el-radio-group v-model="payWithCard.isCard">
            <el-radio-button :label="true">{{ $t("organisation.billing.registerCards") }}</el-radio-button>
            <el-radio-button :label="false">{{ $t("organisation.billing.newCard") }}</el-radio-button>
          </el-radio-group>
          <el-row :gutter="10" v-if="!payWithCard.isCard">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("organisation.billing.cardNo") }}</label>
                </div>
                <el-input v-model="paymentMethods.cardNo" :class="$inputError('cardNo', validationErrors)" v-mask="'####-####-####-####'" placeholder="####-####-####-####"></el-input>
              </div>
            </el-col>
            <el-col :span="24" class="mt-2">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("organisation.billing.nameSurname") }}</label>
                </div>
                <el-input v-model="paymentMethods.holder" :class="$inputError('holder', validationErrors)" placeholder="John Doe"></el-input>
              </div>
            </el-col>
            <el-col :span="8" class="mt-2">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("organisation.billing.month") }}</label>
                </div>
                <el-input v-model="paymentMethods.expireMonth" :class="$inputError('expireMonth', validationErrors)" placeholder="12"></el-input>
              </div>
            </el-col>
            <el-col :span="8" class="mt-2">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("organisation.billing.year") }}</label>
                </div>
                <el-input v-model="paymentMethods.expireYear" :class="$inputError('expireYear', validationErrors)" placeholder="2025"></el-input>
              </div>
            </el-col>
            <el-col :span="8" class="mt-2">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("organisation.billing.cvv") }}</label>
                </div>
                <el-input v-model="paymentMethods.cvc" :class="$inputError('cVC', validationErrors)" placeholder="333"></el-input>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10" v-else>
            <el-col :span="24" v-for="(card, index) in currentPaymentMethods" :key="index">
              <el-radio v-model="payWithCard.cardId" :label="card.id" border class="card-list-item">{{ card.cardFamily }} {{ card.bin }}**********</el-radio>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24" class="mt-2 selswitch">
              <el-switch v-model="paymentMethods.yearly" :active-text="$t('organisation.billing.payYear')" :inactive-text="$t('organisation.billing.payMonth')"></el-switch>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24">
              <div class="confirmation-coupon" :class="coupon.isApplied ? 'is-active' : 'is-passive'">
                <div class="coupon-info">
                  <p>
                    <b>{{ $t("confirmation.couponCode") }}</b>
                  </p>
                  <p>{{ $t("confirmation.couponCodeMsg") }}</p>
                </div>

                <div class="coupon-apply-area">
                  <el-input size="large" :placeholder="$t('confirmation.selectCode')" v-model="coupon.couponCode" :disabled="coupon.isApplied" :clearable="!coupon.isApplied"></el-input>

                  <el-button :type="coupon.isApplied ? 'danger' : 'primary'" :disabled="coupon.onApply" size="mini" @click="applyCodeSubscription">
                    {{ coupon.isApplied ? $t("confirmation.button.remove") : $t("confirmation.button.apply") }}
                  </el-button>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24" class="left-register-checkbox-area mt-2">
              <div class="left-register-checkbox-container">
                <div class="left-checkbox" :key="subscriptionPolicy" :class="{ active: subscriptionPolicy }"><i class="fas fa-check"></i></div>
                <div class="content">
                  <template v-if="$i18n.locale == 'tr'">
                    <div class="agreement" @click="openAgreementDialog(3)">{{ $t("auth.register.distancePolicy") }}</div>
                    <span>okudum onaylıyorum.</span>
                  </template>
                  <template v-else>
                    <span>I have read and approved</span>
                    <div class="agreement" @click="openAgreementDialog(3)">{{ $t("auth.register.distancePolicy") }}</div>
                  </template>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24" v-if="selectPackage != null" class="package-total-container">
              <div class="package-total-info">
                <div class="total-item">
                  <div class="total-item-title">{{ $t("organisation.billing.subscriptionPackage") }}</div>
                  <div class="total-item-count">{{ selectPackage.title }}</div>
                </div>
                <div class="total-item">
                  <div class="total-item-title">{{ $t("organisation.billing.amount") }}</div>
                  <div class="total-item-count">{{ $currency.format(paymentMethods.yearly == true ? priceCalculator(1, selectPackage.price, 0, 0) * 10 : priceCalculator(1, selectPackage.price, 0, 0), { code: "USD" }) }}</div>
                </div>
                <div class="total-item" v-if="coupon.isApplied == true">
                  <div class="total-item-title">{{ $t("organisation.billing.disconts") }}</div>
                  <div class="total-item-count" v-if="coupon.codeInfo">{{ $currency.format(priceCalculator(4, paymentMethods.yearly ? selectPackage.price * 10 : selectPackage.price, 1, coupon.codeInfo.discount), { code: "USD" }) }}</div>
                </div>
                <div class="total-item" :key="coupon.isApplied">
                  <div class="total-item-title">{{ $t("organisation.billing.taxes") }}</div>
                  <div class="total-item-count" v-if="coupon.codeInfo">{{ $currency.format(priceCalculator(2, paymentMethods.yearly ? selectPackage.price * 10 : selectPackage.price, 1, coupon.codeInfo.discount), { code: "USD" }) }}</div>
                  <div class="total-item-count" v-else>{{ $currency.format(priceCalculator(2, paymentMethods.yearly ? selectPackage.price * 10 : selectPackage.price, 1, 0), { code: "USD" }) }}</div>
                </div>
                <div class="total-item">
                  <div class="total-item-title">{{ $t("organisation.billing.total") }}</div>
                  <div class="total-item-count" v-if="coupon.codeInfo">{{ $currency.format(priceCalculator(3, paymentMethods.yearly ? selectPackage.price * 10 : selectPackage.price, 1, coupon.codeInfo.discount), { code: "USD" }) }}</div>
                  <div class="total-item-count" v-else>{{ $currency.format(priceCalculator(3, paymentMethods.yearly ? selectPackage.price * 10 : selectPackage.price, 1, 0), { code: "USD" }) }}</div>
                </div>
              </div>
            </el-col>
            <el-col :span="24" class="iyzico-brand w-100">
              <img src="/static/images/logo_band_colored.svg" alt="" />
            </el-col>
          </el-row>
        </div>
        <div class="modal-footer" slot="footer">
          <div class="left-buttons">
            <el-button @click="buyPlanDialog = false">{{ $t("organisation.billing.cancel") }}</el-button>
          </div>
          <div class="right-buttons" :key="payWithCard.isCard">
            <el-button type="primary" v-if="!payWithCard.isCard" :loading="loading == 'startPlans'" @click.stop="startPlans">{{ $t("organisation.billing.subscribe") }}</el-button>
            <el-button type="primary" v-else @click.stop="startPayWithCard" :loading="loading == 'startPlansWithCard'" :disabled="payWithCard.cardId == null">{{ $t("organisation.billing.subscribe") }}</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog :title="selectPackage != null && selectPackage.values[0] != null ? selectPackage.values[0].title + ' Satın Al' : 'Paket satın Al'" :visible.sync="buyPackageDialog" class="large" center modal-append-to-body :destroy-on-close="true" @closed="handleClose">
      <div id="changeplan-dialog" class="custom-modal">
        <div class="modal-body" :key="resetPackagePaymentDialog">
          <el-radio-group v-model="payWithCard.isCard">
            <el-radio-button :label="true">{{ $t("organisation.billing.registerCards") }}</el-radio-button>
            <el-radio-button :label="false">{{ $t("organisation.billing.newCard") }}</el-radio-button>
          </el-radio-group>
          <el-row :gutter="10" v-if="!payWithCard.isCard">
            <el-col :span="24">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("organisation.billing.cardNo") }}</label>
                </div>
                <el-input v-model="packagePaymentMethods.cardNo" :class="$inputError('cardNo', validationErrors)" v-mask="'####-####-####-####'" :placeholder="'####-####-####-####'"></el-input>
              </div>
            </el-col>
            <el-col :span="24" class="mt-2">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("organisation.billing.nameSurname") }}</label>
                </div>
                <el-input v-model="packagePaymentMethods.holder" :class="$inputError('holder', validationErrors)" placeholder="John Doe"></el-input>
              </div>
            </el-col>
            <el-col :span="8" class="mt-2">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("organisation.billing.month") }}</label>
                </div>
                <el-input v-model="packagePaymentMethods.expireMonth" :class="$inputError('expireMonth', validationErrors)" placeholder="12"></el-input>
              </div>
            </el-col>
            <el-col :span="8" class="mt-2">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("organisation.billing.year") }}</label>
                </div>
                <el-input v-model="packagePaymentMethods.expireYear" :class="$inputError('expireYear', validationErrors)" placeholder="2025"></el-input>
              </div>
            </el-col>
            <el-col :span="8" class="mt-2">
              <div class="registerform-input-container">
                <div class="custom-label">
                  <label>{{ $t("organisation.billing.cvv") }}</label>
                </div>
                <el-input v-model="packagePaymentMethods.cvc" :class="$inputError('cVC', validationErrors)" placeholder="333"></el-input>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10" v-else>
            <el-col :span="24" v-for="(card, index) in currentPaymentMethods" :key="index">
              <el-radio v-model="payWithCard.cardId" :label="card.id" border class="card-list-item">{{ card.cardFamily }} {{ card.bin }}**********</el-radio>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24" class="mt-2">
              <div class="confirmation-coupon" :class="coupon.isApplied ? 'is-active' : 'is-passive'">
                <div class="coupon-info">
                  <p>
                    <b>{{ $t("confirmation.couponCode") }}</b>
                  </p>
                  <p>{{ $t("confirmation.couponCodeMsg") }}</p>
                </div>

                <div class="coupon-apply-area">
                  <el-input size="large" :placeholder="$t('confirmation.selectCode')" v-model="coupon.couponCode" :disabled="coupon.isApplied" :clearable="!coupon.isApplied"></el-input>

                  <el-button :type="coupon.isApplied ? 'danger' : 'primary'" :disabled="coupon.onApply" size="mini" @click="applyCodeSubscription">
                    {{ coupon.isApplied ? $t("confirmation.button.remove") : $t("confirmation.button.apply") }}
                  </el-button>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24" class="left-register-checkbox-area mt-2">
              <div class="left-register-checkbox-container">
                <div class="left-checkbox" :key="distancePolicy" :class="{ active: distancePolicy }"><i class="fas fa-check"></i></div>
                <div class="content">
                  <template v-if="$i18n.locale == 'tr'">
                    <div class="agreement" @click="openAgreementDialog(4)">{{ $t("auth.register.distancePolicy") }}</div>
                    <span>okudum onaylıyorum.</span>
                  </template>
                  <template v-else>
                    <span>I have read and approved</span>
                    <div class="agreement" @click="openAgreementDialog(4)">{{ $t("auth.register.distancePolicy") }}</div>
                  </template>
                </div>
              </div>
            </el-col>
          </el-row>

          <el-row :gutter="10">
            <el-col :span="24" v-if="selectPackage != null" class="package-total-container">
              <div class="package-total-info mr-2">
                <div class="total-item">
                  <div class="total-item-title">{{ $t("organisation.billing.subscriptionPackage") }}</div>
                  <div class="total-item-count">{{ $currency.format(priceCalculator(1, selectPackage.price * selectPackage.count, 0, 0), { code: "USD" }) }}</div>
                </div>
                <div class="total-item">
                  <div class="total-item-title">{{ $t("organisation.billing.amount") }}</div>
                  <div class="total-item-count">{{ selectPackage.count }}</div>
                </div>
                <div class="total-item" v-if="coupon.isApplied == true">
                  <div class="total-item-title">{{ $t("organisation.billing.disconts") }}</div>
                  <div class="total-item-count" v-if="coupon.codeInfo">{{ $currency.format(priceCalculator(4, selectPackage.price * selectPackage.count, 1, coupon.codeInfo.discount), { code: "USD" }) }}</div>
                </div>
                <div class="total-item" :key="coupon.isApplied">
                  <div class="total-item-title">{{ $t("organisation.billing.taxes") }}</div>
                  <div class="total-item-count" v-if="coupon.codeInfo">{{ $currency.format(priceCalculator(2, selectPackage.price * selectPackage.count, 1, coupon.codeInfo.discount), { code: "USD" }) }}</div>
                  <div class="total-item-count" v-else>{{ $currency.format(priceCalculator(2, selectPackage.price * selectPackage.count, 1, 0), { code: "USD" }) }}</div>
                </div>
                <div class="total-item">
                  <div class="total-item-title">{{ $t("organisation.billing.total") }}</div>
                  <div class="total-item-count" v-if="coupon.codeInfo">{{ $currency.format(priceCalculator(3, selectPackage.price * selectPackage.count, 1, coupon.codeInfo.discount), { code: "USD" }) }}</div>
                  <div class="total-item-count" v-else>{{ $currency.format(priceCalculator(3, selectPackage.price * selectPackage.count, 1, 0), { code: "USD" }) }}</div>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="10">
            <el-col :span="24" class="iyzico-brand">
              <img src="/static/images/logo_band_colored.svg" alt="" />
            </el-col>
          </el-row>
        </div>
        <div class="modal-footer" slot="footer">
          <div class="left-buttons">
            <el-button @click="buyPackageDialog = false">{{ $t("organisation.billing.cancel") }}</el-button>
          </div>
          <div class="right-buttons" :key="payWithCard.isCard">
            <el-button type="primary" v-if="!payWithCard.isCard" :loading="loading == 'buyPackageNewCard'" @click.stop="buyPackageNewCard">{{ $t("organisation.billing.buy") }}</el-button>
            <el-button type="primary" v-else @click.stop="buyPackageWithCard" :loading="loading == 'buyPackageWithCard'" :disabled="payWithCard.cardId == null">{{ $t("organisation.billing.buy") }}</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
    <el-dialog class="large" :title="policy.title" :visible.sync="policyDialog">
      <div class="custom-modal">
        <div class="modal-body" v-html="policy.details"></div>
        <div class="modal-footer" slot="footer">
          <div class="left-buttons">
            <el-button @click="policyDialog = false">{{ $t("organisation.billing.close") }}</el-button>
          </div>
          <div class="right-buttons">
            <el-button type="warning" @click="rejectPolicy(policy.type)">{{ $t("organisation.billing.cancel2") }}</el-button>
            <el-button type="primary" @click="acceptPolicy(policy.type)">{{ $t("organisation.billing.accept") }}</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog class="medium" :title="$t('redeemModal.title')" center modal-append-to-body :destroy-on-close="true" :close-on-click-modal="false" :visible.sync="redeemCodeModal">
      <div class="custom-modal">
        <div class="modal-body">
          <div class="redeem-container">
            <span class="text-center">{{ $t("redeemModal.text") }}</span>
            <div class="input container">
              <el-input :placeholder="$t('redeemModal.placeHolder')" :class="$inputError('code', redeemCode.validation)" v-model="redeemCode.code"></el-input>
              <span class="error">{{ $errorMessage("code", redeemCode.validation) }}</span>
            </div>
            <el-button size="medium" type="primary" :loading="loading == 'redeemCode'" @click="subscriptionRedeemCode" round>{{ $t("redeemModal.buttonText") }}</el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
  name: "OrganisationBilling",
  metaInfo() {
    return {
      title: this.$t("eventPageTitle.organisationBilling")
    };
  },
  data() {
    return {
      redeemCodeModal: false,
      redeemCode: {
        code: null,
        validation: []
      },
      resetPaymentDialog: +new Date(),
      resetPackagePaymentDialog: +new Date(),
      coupon: {
        couponCode: null,
        isApplied: null,
        onApply: false,
        codeInfo: null
      },
      distancePolicy: false,
      subscriptionPolicy: false,
      policyDialog: false,
      selectPackage: null,
      buyPackageDialog: false,
      selectTab: 0,
      policy: {},
      showOverview: false,
      validationErrors: [],
      isActive: "Plans",
      showPlans: true,
      showCards: false,
      showPaymentHistory: false,
      showInvoice: false,
      loading: false,
      timeout: null,
      yearly: false,
      filter: {
        skip: 0,
        take: 10,
        page: 1
      },

      activeNames: ["1"],
      setCardLoading: false,
      buyPlanDialog: false,
      invoice: {
        country: null,
        city: null,
        address: null,
        type: 1,
        titleOrFullName: null,
        taxOffice: null,
        taxNumberOrIdentity: null
      },
      payWithCard: {
        isCard: false,
        cardId: null
      },
      packagePaymentMethods: {
        planId: null,
        count: 0,
        cardNo: null,
        holder: null,
        expireYear: null,
        couponCode: null,
        expireMonth: null,
        cvc: null
      },
      paymentMethods: {
        planId: null,
        cardNo: null,
        holder: null,
        expireYear: null,
        expireMonth: null,
        cvc: null,
        yearly: null,
        couponCode: null
      },
      editAddress: false
    };
  },
  computed: {
    overviewInfo() {
      return this.$store.getters.getSubscriptionOverview;
    },
    additionalPlans() {
      return this.$store.getters.getSubscriptionAdditionalPlans;
    },
    handleChange(val) {
      console.log(val);
    },

    plansCategories() {
      return this.$store.getters.getSubscriptionCategories;
    },
    plansInfo() {
      return this.$store.getters.getSubscriptionPlanList;
    },
    activeSubscription() {
      return this.$store.getters.getActiveSubscription;
    },
    activeStorageSubscription() {
      return this.$store.getters.getActiveStorageSubscription;
    },
    activeTeamMemberSubscription() {
      return this.$store.getters.getActiveTeamMemberSubscription;
    },
    getEnums() {
      return this.$store.getters.getEnums;
    },
    countryList() {
      return this.$store.getters.getCountries;
    },
    cityList() {
      return this.$store.getters.getCities;
    },
    currentOrganization() {
      return this.$store.getters.getCurrentOrganization;
    },
    validation() {
      return this.$store.getters.getSubscriptionValidation;
    },
    currentPaymentMethods() {
      return this.$store.getters.getPaymentMethods;
    },
    paymentHistory() {
      return this.$store.getters.getSubscriptionPaymentHistory;
    }
  },
  async created() {
    await Promise.all([this.$store.dispatch("getSubscriptionAdditionalPlans"), this.$store.dispatch("getSubscriptionPlanList"), this.$store.dispatch("getSubscriptionOverview"), this.$store.dispatch("getPaymentMethods"), this.$store.dispatch("getCountries"), this.$store.dispatch("getPaymentHistory", this.filter)]);
  },
  async mounted() {
    if (this.$route.params.id) {
      var res = await this.$client.post("/Subscription/GetPaymentInfo", { id: this.$route.params.id });
      if (res.data.alert.hasError) {
        this.$message.error(res.data.alert.message);
      } else {
        if (res.data.data.item.status == 1) {
          if (res.data.data.item.additionalPackageCount > 0) {
            this.$alert(this.$t("organisation.billing.packageAdded"), this.$t("organisation.billing.paymentSuccess"), {
              confirmButtonText: this.$t("organisation.billing.ok"),
              type: "success",
              confirmButtonClass: "pop-confirm-class",
              center: true
            });
          } else {
            this.$alert(this.$t("organisation.billing.subscriptionUpdated"), this.$t("organisation.billing.paymentSuccess"), {
              confirmButtonText: this.$t("organisation.billing.ok"),
              type: "success",
              confirmButtonClass: "pop-confirm-class",
              center: true
            });
          }
        } else {
          this.$alert(res.data.data.item.errorMessage, this.$t("organisation.billing.paymentFailed"), {
            confirmButtonText: this.$t("organisation.billing.ok"),
            type: "error",
            center: true,
            showClose: false,
            distinguishCancelAndClose: true
          });
        }
      }
    }
  },
  watch: {
    "paymentMethods.yearly": function() {
      this.subscriptionPolicy = false;
      this.coupon.isApplied = false;
      this.coupon.couponCode = null;
      this.coupon.codeInfo = null;
    },

    filter: {
      deep: true,
      handler: async function() {
        if (this.timeout != null) clearTimeout(this.timeout);
        this.timeout = setTimeout(async () => {
          await this.$store.dispatch("getPaymentHistory", this.filter);
        }, 500);
      }
    }
  },
  methods: {
    async subscriptionRedeemCode() {
      this.loading = "redeemCode";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("subscriptionRedeemCode", this.redeemCode.code);
        this.redeemCode.validation = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          this.redeemCodeModal = false;
          this.redeemCode.code = null;
          this.refreshPlans();
          this.$store.dispatch("getSubscriptionOverview");
        }
        this.loading = false;
      }, 500);
    },
    async refreshBilling() {
      this.loading = "refreshBilling";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("getOrganization");

        this.loading = false;
      }, 500);
    },
    async refreshPlans() {
      this.loading = "refreshPlans";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("getSubscriptionAdditionalPlans");
        await this.$store.dispatch("getSubscriptionPlanList");
        this.loading = false;
      }, 500);
    },
    async refreshPaymentMethods() {
      this.loading = "refreshPaymentMethods";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("getPaymentMethods");
        this.loading = false;
      }, 500);
    },
    async refreshPaymentHistory() {
      this.loading = "refreshPaymentHistory";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        await this.$store.dispatch("getPaymentHistory", this.filter);
        this.loading = false;
      }, 500);
    },
    async openInvoice(history) {
      this.loading = history.id + "-history-download";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("getSubscriptionInvoiceUrl", history.invoiceUrl);
        if (!res.data.alert.hasError) {
          window.open(res.data.data.url, "_blank");
        }
        this.loading = false;
      }, 500);
    },
    goMail() {
      window.location.href = "mailto:support@holacon.com";
    },
    priceCalculator(type, price = 0, tax = 0, discount = 0) {
      if (type == 1) {
        //Sabit Fiyat
        return price;
      }
      if (type == 2) {
        //Toplam Vergi
        var taxCount = 0;
        if (discount > 0) {
          taxCount = (price - discount) * tax - (price - discount);
        } else {
          taxCount = price * tax - price;
        }
        return taxCount;
      }
      if (type == 3) {
        //Toplam Fiyat
        var total = 0;
        if (discount > 0) {
          total = (price - discount) * tax;
        } else {
          total = price * tax;
        }
        return total;
      }
      if (type == 4) {
        //İndirim Fiyatı
        return discount;
      }
    },
    async applyCodeSubscription() {
      var payload = {
        planId: this.selectPackage.id,
        code: this.coupon.couponCode,
        yearly: this.paymentMethods.yearly,
        count: this.selectPackage.count != undefined ? this.selectPackage.count : null
      };
      if (this.timeout != null) clearTimeout(this.timeout);
      this.coupon.onApply = true;

      this.timeout = setTimeout(async () => {
        if (this.coupon.isApplied) {
          this.coupon.isApplied = false;
          this.coupon.couponCode = null;
          this.coupon.codeInfo = null;
        } else {
          var res = await this.$store.dispatch("subscriptionValidationCouponCode", payload);
          if (!res.data.alert.hasError) {
            this.coupon.isApplied = true;
            this.coupon.codeInfo = res.data.data;
          }
        }
        this.subscriptionPolicy = false;
        this.distancePolicy = false;
        this.coupon.onApply = false;
      }, 500);
    },
    handleClose() {
      this.distancePolicy = false;
      this.subscriptionPolicy = false;
      this.coupon.couponCode = null;
      this.coupon.isApplied = false;
      this.coupon.codeInfo = null;
      this.validationErrors = [];

      var resetPackageMethods = {
        planId: null,
        count: 0,
        cardNo: null,
        holder: null,
        expireYear: null,
        couponCode: null,
        expireMonth: null,
        cvc: null
      };
      var resetMethods = {
        planId: null,
        yearly: false,
        cardNo: null,
        holder: null,
        expireYear: null,
        couponCode: null,
        expireMonth: null,
        cvc: null
      };
      this.paymentMethods = resetMethods;
      this.packagePaymentMethods = resetPackageMethods;
      this.resetPaymentDialog += 1;
      this.resetPackagePaymentDialog += 1;
    },
    rejectPolicy(type) {
      if (type == 4) {
        this.distancePolicy = false;
      }
      if (type == 3) {
        this.subscriptionPolicy = false;
      }
      this.policyDialog = false;
    },
    acceptPolicy(type) {
      if (type == 4) {
        this.distancePolicy = true;
      }
      if (type == 3) {
        this.subscriptionPolicy = true;
      }
      this.policyDialog = false;
    },
    async openAgreementDialog(type) {
      var payload = {
        type: type,
        count: null,
        planId: null,
        yearly: null,
        couponCode: null
      };
      if (this.coupon.isApplied) {
        payload.couponCode = this.coupon.couponCode;
      }
      if (type == 3) {
        payload.planId = this.selectPackage.id;
        payload.yearly = this.paymentMethods.yearly;
      }
      if (type == 4) {
        payload.planId = this.selectPackage.id;
        payload.count = this.selectPackage.count;
      }
      var res = await this.$store.dispatch("getPolicy", payload);
      if (!res.data.alert.hasError) {
        this.policy = res.data.data.item;
        this.policyDialog = true;
      }
    },
    async resetPaymentMethodErrorCount(cardId) {
      await this.$store.dispatch("resetPaymentMethodErrorCount", { id: cardId });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.errorCount == 0) {
        return "row-active";
      }
      return "row-passive";
    },
    async buyPackageWithCard() {
      this.loading = "buyPackageWithCard";
      if (this.timeout != null) clearTimeout(this.timeout);

      this.timeout = setTimeout(async () => {
        if (this.payWithCard.cardId == null) {
          this.$t("organisation.billing.paymentSuccess");
          this.$message.info(this.$t("organisation.billing.selectCard"));
          this.loading = false;
          return;
        }
        if (this.distancePolicy != true) {
          this.$message.warning(this.$t("organisation.billing.approveContracts"));
          this.loading = false;

          return;
        }
        var payload = {
          cardId: this.payWithCard.cardId,
          planId: this.packagePaymentMethods.planId,
          count: this.packagePaymentMethods.count,
          couponCode: null
        };
        if (this.coupon.isApplied) {
          payload.couponCode = this.coupon.couponCode;
        }
        var res = await this.$store.dispatch("buyAdditionalPackageWithCard", payload);
        if (!res.data.alert.hasError) {
          this.buyPackageDialog = false;

          var paymentInfo = await this.$client.post("/Subscription/GetPaymentInfo", { id: res.data.data.id });
          if (paymentInfo.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            if (paymentInfo.data.data.item.status == 1) {
              this.$alert(this.$t("organisation.billing.packageAdded"), this.$t("organisation.billing.paymentSuccess"), {
                confirmButtonText: this.$t("organisation.billing.ok"),
                type: "success",
                confirmButtonClass: "pop-confirm-class",
                center: true
              });
            } else {
              this.$alert(paymentInfo.data.data.item.errorMessage, this.$t("organisation.billing.paymentFailed"), {
                confirmButtonText: this.$t("organisation.billing.ok"),
                type: "error",
                center: true,
                showClose: false,
                distinguishCancelAndClose: true
              });
            }
            await Promise.all([this.$store.dispatch("getSubscriptionAdditionalPlans"), this.$store.dispatch("getSubscriptionPlanList"), this.$store.dispatch("getPaymentMethods"), this.$store.dispatch("getPaymentHistory", this.filter)]);
          }
        }
        this.loading = false;
      }, 500);
    },
    async startPayWithCard() {
      this.loading = "startPlansWithCard";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        if (this.payWithCard.cardId == null) {
          this.$message.info(this.$t("organisation.billing.selectCard"));
          this.loading = false;
          return;
        }
        if (this.subscriptionPolicy != true) {
          this.$message.warning(this.$t("organisation.billing.approveContracts"));
          this.loading = false;
          return;
        }
        var payload = {
          cardId: this.payWithCard.cardId,
          planId: this.paymentMethods.planId,
          yearly: this.paymentMethods.yearly,
          couponCode: null
        };
        if (this.coupon.isApplied) {
          payload.couponCode = this.coupon.couponCode;
        }
        var res = await this.$store.dispatch("startWithCardSubscription", payload);
        if (!res.data.alert.hasError) {
          this.buyPlanDialog = false;

          var paymentInfo = await this.$client.post("/Subscription/GetPaymentInfo", { id: res.data.data.id });
          if (paymentInfo.data.alert.hasError) {
            this.$message.error(res.data.alert.message);
          } else {
            if (paymentInfo.data.data.item.status == 1) {
              this.$alert(this.$t("organisation.billing.subscriptionUpdated"), this.$t("organisation.billing.paymentSuccess"), {
                confirmButtonText: this.$t("organisation.billing.ok"),
                type: "success",
                confirmButtonClass: "pop-confirm-class",
                center: true
              });
            } else {
              this.$alert(paymentInfo.data.data.item.errorMessage, this.$t("organisation.billing.paymentFailed"), {
                confirmButtonText: this.$t("organisation.billing.ok"),
                type: "error",
                center: true,
                showClose: false,
                distinguishCancelAndClose: true
              });
            }
            await Promise.all([this.$store.dispatch("getSubscriptionAdditionalPlans"), this.$store.dispatch("getSubscriptionPlanList"), this.$store.dispatch("getPaymentMethods"), this.$store.dispatch("getPaymentHistory", this.filter)]);
          }
        }
        this.loading = false;
      }, 500);
    },
    handleSizeChange(take) {
      this.filter.take = take;
    },

    handleCurrentChange(page) {
      this.filter.page = page;
    },
    async deletePaymentMethod(id) {
      await this.$store.dispatch("subscriptDeletePaymentMethod", id);
    },
    async cancelSubscription(id) {
      await this.$store.dispatch("cancelSubscription", id);
    },
    async cancelCancelSubscription(id) {
      await this.$store.dispatch("cancelCancelSubscription", id);
    },
    async setPrimaryCard(id) {
      this.setCardLoading = id;
      await this.$store.dispatch("setPrimaryCard", id);
      this.setCardLoading = false;
    },
    async updateBilling() {
      this.loading = "updateBilling";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        var res = await this.$store.dispatch("updateBillingInfo", this.currentOrganization.invoice);
        if (!res.data.alert.hasError) {
          await this.$store.dispatch("getOrganization");
        }
        this.loading = false;
      }, 500);
    },
    buyPlans(item) {
      this.selectPackage = item;
      if (this.currentOrganization.invoice.address == null) {
        this.showInvoice = true;
        this.$message.info(this.$t("organisation.billing.editInfo"));
      } else {
        this.paymentMethods.planId = item.id;
        this.buyPlanDialog = true;
      }
    },
    buyPackage(additionalPackage) {
      if (this.currentOrganization.invoice.address == null) {
        this.showInvoice = true;
        this.$message.info(this.$t("organisation.billing.editInfo"));
      } else {
        this.selectPackage = additionalPackage;
        this.packagePaymentMethods.planId = additionalPackage.id;
        this.packagePaymentMethods.count = additionalPackage.count;
        this.buyPackageDialog = true;
      }
    },
    async buyPackageNewCard() {
      this.loading = "buyPackageNewCard";
      if (this.timeout != null) clearTimeout(this.timeout);

      this.timeout = setTimeout(async () => {
        if (this.distancePolicy != true) {
          this.$message.warning(this.$t("organisation.billing.approveContracts"));
          this.loading = false;
          return;
        }
        if (this.coupon.isApplied) {
          this.packagePaymentMethods.couponCode = this.coupon.couponCode;
        }
        this.packagePaymentMethods.cardNo = this.packagePaymentMethods.cardNo != null ? this.packagePaymentMethods.cardNo.replaceAll("-", "") : null;
        var res = await this.$store.dispatch("buyAdditionalPackage", this.packagePaymentMethods);
        this.validationErrors = res.data.validationErrors;
        if (!res.data.alert.hasError) {
          window.jQuery("#hidden").html(res.data.data.threedHtml);
          window
            .jQuery("#hidden")
            .find("form")
            .submit();
        } else {
          this.editAddress = true;
        }
        this.loading = false;
      }, 500);
    },
    async startPlans() {
      this.loading = "startPlans";
      if (this.timeout != null) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        if (this.subscriptionPolicy != true) {
          this.$message.warning(this.$t("organisation.billing.approveContracts"));
          this.loading = false;
          return;
        }
        this.paymentMethods.cardNo = this.paymentMethods.cardNo != null ? this.paymentMethods.cardNo.replaceAll("-", "") : null;
        if (this.coupon.isApplied) {
          this.paymentMethods.couponCode = this.coupon.couponCode;
        }
        var res = await this.$store.dispatch("startSubscription", this.paymentMethods);
        this.validationErrors = res.data.validationErrors;

        if (!res.data.alert.hasError) {
          window.jQuery("#hidden").html(res.data.data.threedHtml);
          window
            .jQuery("#hidden")
            .find("form")
            .submit();
        }
        this.loading = false;
      }, 500);
    }
  }
};
</script>

<style lang="less">
.iyzico-brand {
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  margin-top: 0.5rem;
  img {
    max-height: 40px;
  }
}
.confirmation-coupon {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  text-align: left;
  border-radius: 8px;
  padding: 16px 14px;
  margin: 4px 0px;
  transition: border-color 0.3s, background-color 0.3s;

  .coupon-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    text-align: left;

    p {
      color: #505763;
      font-weight: 400;
      font-size: 14px;

      b {
        font-size: 16px;
        font-weight: 600;
        color: #292f3b;
      }
    }
  }

  .coupon-apply-area {
    display: flex;
    min-width: 250px;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    .el-input {
      .el-input__inner {
        border-top-right-radius: 0px !important;
        border-bottom-right-radius: 0px !important;
      }
    }

    .el-button {
      border-top-left-radius: 0px !important;
      border-bottom-left-radius: 0px !important;
      height: 40px;
    }
  }

  &.is-passive {
    background: #fff2f2;
  }

  &.is-active {
    background-color: #e5f7fb;
  }
}

.package-total-container {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
  .package-total-info {
    display: flex;
    flex-direction: column;
    gap: 5px;
    .total-item {
      display: flex;
      flex-direction: row;
      gap: 5px;
      .total-item-title {
        font-weight: bold;
      }
    }
  }
}

.autocheckin-click {
  text-decoration: underline;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  display: block;
}
#organisation-billing {
  .left-register-checkbox-area {
    display: flex;
    flex-direction: column;
    gap: 8px;
    .left-register-checkbox-container {
      display: flex;
      align-items: center;
      height: 24px;
      & > .content {
        display: flex;
        cursor: pointer;
        align-items: center;
        gap: 5px;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        letter-spacing: 0.2px;
        & > .agreement {
          text-decoration-line: underline;
          color: #268ea6;
        }
        & > span {
          font-weight: 400;
          text-decoration-line: unset;
          color: #292f3b;
        }
      }
      .left-checkbox {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 6px 4px;
        width: 24px;
        &.active {
          background: #268ea6;
          i {
            display: block;
          }
        }
        background-color: #f1f3f6;
        height: 24px;
        border: 1px solid #c1e8f1;
        border-radius: 5px;
        i {
          display: none;
          color: white;
          width: 14.5px;
          height: 10px;
          font-size: 14.5px;
        }
      }
    }
  }
  .add-services-container {
    box-shadow: unset;
    border-radius: 8px;
    overflow: hidden;
  }
  .additional-package-list {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 10px;
    .additional-package-item {
      background-color: #f1f1f1;
      border-radius: 8px;
      padding: 10px;
      gap: 10px;
      display: flex;
      flex-direction: column;
      position: relative;
      text-align: center;
      .additional-package-title {
        font-weight: 600;
        font-size: 20px;
      }
      .additional-package-desc {
        font-weight: 400;
        font-size: 13px;
        color: #505763;
      }
      .additional-package-price {
        font-weight: 500;
        font-size: 16px;
      }
      .additional-package-buy-button {
        right: 5px;
        top: 5px;
      }
    }
  }
  .plans-container-flex {
    display: flex;
    flex-direction: column;
    gap: 10px;
  }
  .plans-body-grid {
    display: flex;
    flex-direction: column;
    gap: 5px;
    .plans-body-grid-head {
      span {
        font-weight: bold;
        font-size: 18px;
      }
      display: flex;
      height: 40px;
      align-items: center;
      justify-content: space-between;
      padding: 1rem 0.5rem;
      background-color: #f1f1f1;
      border-radius: 8px;

      i {
        transition: all 0.2s;
        transform: rotate(0);

        &.active {
          transition: all 0.2s;
          transform: rotate(-180deg);
        }
      }
    }
    .plans-body-grid-list {
      display: flex;
      flex-direction: column;
      .plans-body-list-item {
        min-height: 40px;
        display: grid;
        grid-template-columns: 1fr 200px 200px 200px 200px;
        align-items: center;
        padding: 10px;
        text-align: center;
        .item-head {
          text-align: start;
          font-weight: 500;
        }
        .item-grid-content {
          i {
            color: #70ad47;
            &.gray {
              color: #d0cece;
            }
          }
        }
        &:nth-child(odd) {
          background-color: white;
        }
        &:nth-child(even) {
          background-color: #fafafa;
        }
      }
    }
  }
  .free-plan-card {
    border: 1px solid #dcdfe6;
    border-radius: 8px;
    padding: 16px !important;
    position: relative;
    text-align: left;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    .plan-header {
      h3 {
        font-weight: 600;
        font-size: 22px;
        color: #292f3b;
        margin: 0px;
      }
      span {
        color: #505763;
        font-size: 14px;
        display: block;

        button {
          background: unset;
          border: unset;
          color: #03658c;
          text-decoration: underline;
          margin: 0px;
          padding: 0px;
        }
      }
    }
  }

  .enterprise-plan-card {
    background: linear-gradient(222deg, #09658c, #288da5, #55bcbc);
    background-size: 600% 600%;
    -webkit-animation: AnimationName 14s ease infinite;
    -moz-animation: AnimationName 14s ease infinite;
    -o-animation: AnimationName 14s ease infinite;
    animation: AnimationName 14s ease infinite;
    border-radius: 8px;
    padding: 16px !important;
    position: relative;
    text-align: left;
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    // margin: 28px 0px;
    margin-top: 28px;

    .plan-header {
      h3 {
        font-weight: 600;
        font-size: 22px;
        color: white;
        margin: 0px;
      }
      span {
        color: white;
        font-size: 14px;
        display: block;

        button {
          background: unset;
          border: unset;
          color: white;
          text-decoration: underline;
          margin: 0px;
          padding: 0px;
        }
      }
    }

    .plan-footer {
      button {
        color: #3d658b;
        background: white;
        border: unset;
      }
    }
  }

  .subs-header {
    box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.16);
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-radius: 8px;
    padding: 24px !important;
    margin: 28px 0px;

    h3 {
      font-weight: 600;
      font-size: 18px;
      color: #292f3b;
      margin: 0px;
      padding: 0px;
    }

    .el-switch__label {
      span {
        font-size: 16px;
        font-weight: 600;
      }
    }
  }

  .plans-container {
    display: flex;
    flex-direction: column;
    position: relative;
    .plans-grid-template {
      background-color: white;
      z-index: 2;
      display: grid;
      grid-template-columns: 1fr 200px 200px 200px 200px;
      text-align: center;
      position: -webkit-sticky; /* Safari */
      position: sticky;
      top: 53px;
      padding: 10px;
    }

    .plans-header {
      .plan-item-header {
        .plan-title {
          font-weight: 600;
          font-size: 20px;
        }
        .plan-price {
          font-weight: 500;
          font-size: 16px;
        }
      }
    }

    .plans-body {
      .el-table__header-wrapper {
        display: none;
      }
      .el-collapse-item__header {
        font-size: 16px;
        font-weight: 600;
      }
    }

    .plan-item {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      border-right: 1px solid #dcdfe6;
      border-top: 1px solid #dcdfe6;
      border-bottom: 1px solid #dcdfe6;
      overflow: hidden;

      &:first-child {
        border-left: 1px solid #dcdfe6;
        border-top-left-radius: 8px;
        border-bottom-left-radius: 8px;
      }

      &:last-child {
        border-top-right-radius: 8px;
        border-bottom-right-radius: 8px;
      }

      .plan-header {
        background-color: #eef3f3;
        border-bottom: 1px solid #dcdfe6;
        width: 100%;
        min-height: 126px;
        padding: 4px;
        text-align: center;
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        &.activesub {
          background-color: #50bfbf;

          .plan-title {
            color: white;
          }

          .plan-price {
            color: white;
          }
        }

        .plan-title {
          font-weight: 600;
          font-size: 22px;
          color: #292f3b;
        }
        .plan-price {
          font-size: 16px;
          font-weight: 500;
          color: #505763;
        }
        .active-sub {
          background-color: #03658c;
          border: 1px solid white;
          padding: 6px 12px;
          border-radius: 60px;
          span {
            color: white;
            display: block;
            font-weight: 500;
          }
        }
      }
      .plan-body {
        padding: 8px;
        height: 100%;

        .section {
          margin: 8px 0px;
          width: 100%;
          border-radius: 8px;
          padding: 6px;

          .section-header {
            width: 100%;
            cursor: pointer;
            text-align: center;
            h3 {
              font-size: 15px;
              font-weight: 600;
              color: #292f3b;
              margin: 0px;
              i {
                margin-left: 6px;
                font-size: 12px;
                color: #50bfbf;
              }
            }
          }
          .section-body {
            margin-top: 16px;
            text-align: center;
            opacity: 1;
            transition: opacity 1s ease-out;

            &[style*="display: none;"] {
              opacity: 0;
            }

            span {
              font-size: 13px;
              display: block;
              font-weight: 500;
              width: 100%;
              margin: 4px 0px;

              .el-tooltip {
                color: #505763;
                font-size: 12px;
              }
              b {
                margin-left: 6px;
                color: #292f3b;
                i {
                  color: #50bfbf;
                }
              }
            }
          }
        }
      }
      .plan-footer {
        border-top: 1px solid #dcdfe6;
        background-color: #eef3f3;
        width: 100%;
        padding: 16px;
        text-align: center;
        justify-self: end;
      }
    }
  }

  .cards-proc {
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
  }

  .errcount {
    margin-left: 16px;
    span {
      font-weight: 500;
    }
  }

  .payment-status {
    span {
      display: block;

      &:first-child {
        font-weight: 500;
      }
    }
  }

  .subs-plan {
    span {
      display: block;

      &:first-child {
        font-weight: 500;
      }
    }
  }

  .cancellation {
    margin-top: 24px;

    button {
      border: unset;
      padding: unset;
      margin: unset;
      background: unset;
      text-decoration: underline;
      color: #03658c;
    }
  }

  #changeplan-dialog {
    .card-list-item {
      width: 100%;
    }

    .selswitch {
      background-color: #fbfbfb;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 12px;
      border-radius: 8px;
    }
  }
}

@-webkit-keyframes AnimationName {
  0% {
    background-position: 97% 0%;
  }
  50% {
    background-position: 4% 100%;
  }
  100% {
    background-position: 97% 0%;
  }
}
@-moz-keyframes AnimationName {
  0% {
    background-position: 97% 0%;
  }
  50% {
    background-position: 4% 100%;
  }
  100% {
    background-position: 97% 0%;
  }
}
@-o-keyframes AnimationName {
  0% {
    background-position: 97% 0%;
  }
  50% {
    background-position: 4% 100%;
  }
  100% {
    background-position: 97% 0%;
  }
}
@keyframes AnimationName {
  0% {
    background-position: 97% 0%;
  }
  50% {
    background-position: 4% 100%;
  }
  100% {
    background-position: 97% 0%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/OrganisationBilling.vue